let mobile_screen_size = 1024

export const drag_enabled = (width, editable) => {
  if (width <= mobile_screen_size) {
    return false
  } else {
    return editable
  }
}
